// =============================================
// useOrgFilter — centralized org filter hook
// KipiKid - מסנן ארגון לממשקי ניהול
// =============================================

import { useAuthStore } from '../stores/authStore';
import { useAdminStore } from '../stores/adminStore';

export function useOrgFilter() {
  const { user } = useAuthStore();
  const { selectedOrganizationId } = useAdminStore();
  const orgFilter = user?.organizationPublicId || selectedOrganizationId || undefined;
  const isSysAdmin = !user?.organizationPublicId;
  return { orgFilter, isSysAdmin, user };
}
